module.exports = __webpack_public_path__ + "media/images/staff-member-nav-hover-3545f5ac897778db632b74771e3d8e0c.svg";